module.exports = __webpack_public_path__ + "static/img/221_TO8_1944_og.42b64f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/221_TO8_1944_og.jpg
// module id = Q2yf
// module chunks = 0